import { FETCH_USERS_SUCCEEDED } from '../actions/ActionTypes';
const users = (state = {}, action) => {
  switch (action.type) {
    case FETCH_USERS_SUCCEEDED:
      return action.response.users.reduce((result, user) => Object.assign({}, result, {
        [user.id]: user
      }), {});
    default:
      return state;
  }
};
export default users;